import type { QNotifyCreateOptions } from 'quasar';
import {
  lucideAlertTriangle,
  lucideCircleCheck,
  lucideCircleX,
  lucideInfo,
  lucideX
} from 'quasar-extras-svg-icons/lucide-icons';

export enum NotifStatus {
  NEW = 'new',
  SEEN = 'seen',
  READ = 'read',
  ARCHIVED = 'archived'
}

export enum NotifFolders {
  GLOBAL = 'global',
  ARCHIVES = 'archives'
}

export enum NotifTypes {
  ANNOUNCEMENT = 'announce',
  DECLARATION = 'decl',
  AUDIT = 'audit',
  REG_MONITORING = 'regmonitor',
  NEW_DECLARATION_STATUS = 'new_declaration_status',
  OCR_JOB = 'ocr_job',
  BTI = 'bti',
  DUTY = 'duty',
  PROCESSING_TIME = 'processing_time',
  BANNER = 'banner'
  // Uncomment if needed:
  // LEGAL = 'legal_publication',
  // NOMENC = 'nomenc_code'
}

export const COMMON_NOTIFICATION_PROPS: QNotifyCreateOptions = {
  classes: 'cb-notif-animation bg-chip prime-shadow text-weight-bold rounded-8px',
  badgeClass: 'bg-negative text-white rounded-full',
  position: 'bottom-right'
};

export const POSITIVE_NOTIFICATION_PROPS: QNotifyCreateOptions = {
  ...COMMON_NOTIFICATION_PROPS,
  icon: lucideCircleCheck,
  textColor: 'positive',
  actions: [
    {
      icon: lucideX,
      color: 'positive',
      size: 'sm',
      round: true,
      handler: () => {}
    }
  ]
};

export const WARNING_NOTIFICATION_PROPS: QNotifyCreateOptions = {
  ...COMMON_NOTIFICATION_PROPS,
  icon: lucideAlertTriangle,
  textColor: 'warning',
  actions: [
    {
      icon: lucideX,
      color: 'warning',
      size: 'sm',
      round: true,
      handler: () => {}
    }
  ]
};

export const NEGATIVE_NOTIFICATION_PROPS: QNotifyCreateOptions = {
  ...COMMON_NOTIFICATION_PROPS,
  icon: lucideCircleX,
  textColor: 'negative',
  actions: [
    {
      icon: lucideX,
      color: 'negative',
      size: 'sm',
      round: true,
      handler: () => {}
    }
  ]
};

export const PRIMARY_NOTIFICATION_PROPS: QNotifyCreateOptions = {
  ...COMMON_NOTIFICATION_PROPS,
  icon: lucideInfo,
  textColor: 'primary',
  actions: [
    {
      icon: lucideX,
      color: 'primary',
      size: 'sm',
      round: true,
      handler: () => {}
    }
  ]
};

